import type { ColumnPosition, PorchColumnPattern } from "building-types/columns/porchColumnPattern";
import { ascendingSortCompare } from "geom/utils";

export function porchColumnPatternNew(positions: ColumnPosition[]): PorchColumnPattern {
  return { positions };
}
interface ExplicitPosition {
  readonly param: number;
  readonly rotated: boolean;
}
function positionSortCompare(a: ExplicitPosition, b: ExplicitPosition) {
  return ascendingSortCompare(a.param, b.param);
}

export function columnPositionsToNormalizedParams(
  positions: ColumnPosition[],
  edgeLength: number,
  mirror: boolean,
): [number[], boolean[]] {
  let size = 0;
  let explicitParam = 0;
  const params = new Set();
  const uniqueParams: ExplicitPosition[] = [];
  for (const pos of positions) {
    if (pos.paramNormalized) {
      explicitParam = mirror ? 1 - pos.param : pos.param;
    } else {
      explicitParam = mirror ? 1 - pos.param / edgeLength : pos.param / edgeLength;
    }
    params.add(explicitParam);
    if (params.size - size === 1) {
      uniqueParams.push({ param: explicitParam, rotated: !!pos.rotated });
      size++;
    }
  }

  uniqueParams.sort(positionSortCompare);

  return [uniqueParams.map((p) => p.param), uniqueParams.map((p) => p.rotated)];
}
